/**
 * V-2093: Zwischenstand des Amazon-Einrichtungsassistenten im Browser. Seit V-2093 ohne Geheimnisse;
 * Altbestände (Client-Secret/Refresh-Token im Klartext, möglich seit 01.02.2026) müssen aber auch dann
 * verschwinden, wenn niemand die Amazon-Unterseite öffnet. Deshalb räumt diese Funktion beim App-Start
 * und bei jeder Abmeldung den Schlüssel weg (der Stand ist nicht je Mandant/Benutzer getrennt).
 */
export const AMAZON_ASSISTENT_SPEICHER_KEY = 'amazon-setup-wizard-progress';

export function loescheAmazonAssistentStand(): void {
  try {
    localStorage.removeItem(AMAZON_ASSISTENT_SPEICHER_KEY);
  } catch {
    // Browser-Speicher nicht verfügbar (privates Fenster) — dann liegt auch nichts darin.
  }
}

/** App-Start: nur ein Altbestand MIT Geheimnisfeldern wird entfernt; ein sauberer Stand bleibt zum Fortsetzen. */
export function bereinigeAmazonAssistentAltbestand(): void {
  try {
    const roh = localStorage.getItem(AMAZON_ASSISTENT_SPEICHER_KEY);
    if (roh === null) return;
    let enthaeltGeheimnis = true; // unlesbar = im Zweifel entfernen
    try {
      const p = JSON.parse(roh) as Record<string, unknown> | null;
      enthaeltGeheimnis = !p || typeof p !== 'object' || !!p.clientSecret || !!p.refreshToken;
    } catch {
      enthaeltGeheimnis = true;
    }
    if (enthaeltGeheimnis) localStorage.removeItem(AMAZON_ASSISTENT_SPEICHER_KEY);
  } catch {
    // Kein Browser-Speicher.
  }
}
